import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
	routes: [
		{
			path: '/',
			name: 'login-home',
			component: () => import('./views/LoginHome.vue')
		},
		{
			path: '/home',
			name: 'home',
			component: () => import('./views/Home.vue'),
			children: [
				{
					path: '/group-device-software',
					name: 'group-device-software',
					component: () => import('./views/home/GroupDeviceSoftware.vue')
				},
				{
					path: '/bulk-creation',
					name: 'bulk-creation',
					component: () => import('./views/home/BulkDeviceCreation.vue')
				},
				{
					path: '/',
					name: 'bulk-creation',
					component: () => import('./views/home/BulkDeviceCreation.vue')
				}
			]
		}
	]
})
